//
import {queryList, addOrderMivManualNotice, initUpdate, updateOrderMivManualNotice, orderDetailInfo, manualNotice, getDeleteOrderMivManualNoticeList} from './../api';
import { Message } from 'element-ui';
import { carrierList, custTypeList, shippingCityList } from '../../../../api'
import { rePush } from '../../../log/interfaceLog/api'
const orderMivManualNotice = {
    namespaced: true,
    state: {
        successCode:200,
        resp:null,
        carrierListObj:null,
        custTypeListObj:null,
        shippingCityListObj:null,
        addOrderMivManualNoticeData:null,
        initUpdateObj:null,
        updateOrderMivManualNoticeData:null,
        orderDetailInfoObj:null,
        orderDetailTotal: null,
        manualNoticeObj:null,
        deleteOrderMivManualNoticeList:null,
        total:null,
    },
    mutations: {
      QUERY_LIST(state,resp){
            if (resp.code === state.successCode){
              Message({showClose: true, message: resp.msg, type: 'success'});
            }
            // state.resp = resp.obj || [];
            state.resp = (resp.obj || []).map(item => ({ ...item, btns: [true, true, item.status == '10', true] }));
            state.total = resp.total
        },
      ADD_ORDER_MIV_MANUAL_NOTICE(state, data){
          state.addOrderMivManualNoticeData = data
      },
      INIT_UPDATE(state, data){
        state.initUpdateObj = data.obj;
      },
      UPDATE_ORDER_MIV_MANUAL_NOTICE(state, data){
        state.updateOrderMivManualNoticeData = data
      },
      ORDER_DETAIL_INFO(state, data){
        state.orderDetailInfoObj = data.obj || [];
        state.orderDetailTotal = data.total;
      },
      MANUAL_NOTICE(state,data){
        state.manualNoticeObj = data;
      },

      GET_DELETE_CLIENT_LIST(state, data){
        state.deleteOrderMivManualNoticeList = data
      },
      GET_INIT_CLIENT_INFO(state,data){
        state.initClientInfo = data;
      },
      CARRIER_LIST_DATA(state, resp){
        state.carrierListObj = resp.obj || [];
      },
      CUST_TYPE_LIST_DATA(state, resp){
        state.custTypeListObj = resp.obj || [];
      },
      SHIPPING_CITY_LIST_DATA(state, resp){
        state.shippingCityListObj = resp.obj || [];
      },

    },
    actions: {

       async queryList({commit}, obj){
           let resp = await queryList(obj);
           commit('QUERY_LIST', resp);
        },
        async addOrderMivManualNotice({commit}, obj){
          let resp = await addOrderMivManualNotice(obj);
          commit('ADD_ORDER_MIV_MANUAL_NOTICE', resp);
        },
        async initUpdate({commit}, obj){
          let resp = await initUpdate(obj);
          commit('INIT_UPDATE', resp);
        },
        async updateOrderMivManualNotice({commit}, obj){
          let resp = await updateOrderMivManualNotice(obj);
          commit('UPDATE_ORDER_MIV_MANUAL_NOTICE', resp);
        },
        async orderDetailInfo({commit}, obj){
          let resp = await orderDetailInfo(obj);
          commit('ORDER_DETAIL_INFO', resp);
        },
        //manualNotice
        async manualNotice({ commit }, obj) {
          let resp = await manualNotice(obj);
          commit('MANUAL_NOTICE', resp);
        },
        async getDeleteOrderMivManualNoticeList({commit}, obj){
        let resp = await getDeleteOrderMivManualNoticeList(obj);
        commit('GET_DELETE_CLIENT_LIST', resp);
      },


      //承运商
      async carrierList({ commit }, obj) {
        let resp = await carrierList(obj);
        commit('CARRIER_LIST_DATA', resp);
      },

      //客户类型
      async custTypeList({ commit }, obj) {
        let resp = await custTypeList(obj);
        commit('CUST_TYPE_LIST_DATA', resp);
      },

      //发货城市
      async shippingCityList({ commit }, obj) {
        let resp = await shippingCityList(obj);
        commit('SHIPPING_CITY_LIST_DATA', resp);
      },

    }
}

export default orderMivManualNotice



// WEBPACK FOOTER //
// ./src/page/bd/orderMivManualNotice/store/orderMivManualNotice.store.js